import Button from 'components/_parts/atoms/button';
import CustomTable from 'components/_parts/atoms/table';
import LoadingCustom from 'components/layouts/loading/loading';
import dayjs from 'dayjs';
import { useOuterClick } from 'providers/OutsideClick';
import { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HIT_ACTIVITY_MOVE_ORDER } from 'redux/actions/company';
import styled from 'styled-components';
import { useActivityMoveOrderMutation } from 'components/company/hooks/useCompany';
import ModalActivityType from '../modal';
import dataStatus from './dataStatus';


interface PropTypes {
  t: (e:string) => string
}

const CustomTableMod = styled.div`
  [data-column-id="7"] {
    padding: 2px;
  }
  .rdt_TableBody {
    height: 500px;
    overflow: auto;
  }
  [data-sort-id="3"], 
  [data-sort-id="4"], 
  [data-sort-id="5"],
  [data-sort-id="6"] {
    justify-content: start;
  },
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;
const ButtonEdit = styled(Button)`
  width: 100%;
  max-width: 70px;
  height: 24px;
  float: right;
`;
const customStyles = {
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: 'Quicksand',
      padding: '0px',
      justifyContent: 'start',
    },
  },
  cells: {
    style: {
      padding: '0px',
      justifyContent: 'start',
    },
  },
  rows: {
    style: {
      fontFamily: 'Quicksand',
      minHeight: '35px', // override the row height
      borderRadius: 0,
      filter: 'none',
      borderBottom: 'unset !important',
      marginBottom: '0px',
    },
  },
};

function Index(props: PropTypes) {
  const { t } = props;
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [typeForm, setTypeForm] = useState('');
  const [id, setId] = useState(null);
  const [dataEdit, setDataEdit] = useState(null);
  const activityMoveOrderMutation = useActivityMoveOrderMutation();
  const { ActivityTypeList, keyCompanyType } = useSelector((state) => ({
    ActivityTypeList: state?.wla?.activity_type_list,
    keyCompanyType: state?.loading?.listKey?.companyType,
  }));

  const innerRef = useOuterClick((e) => {
    if (
      e?.srcElement?.className && (e.srcElement?.className === 'modal fade show'
          || e.srcElement?.className?.includes('cs_modal-bg'))
    ) {
      setShowModal(false);
      setId(null);
    }
  });

  const handleOrdering = (id:string, type: string) => {
    const payload = {
      wla_activity_type_id: id,
      type,
    };
    activityMoveOrderMutation.mutate({
      data: payload,
    });
  };

  const dataStatusCell = ({ row, t }) => (
    <div className="new_company_settings_act_type text-capitalize">
      {dataStatus({ data: row.status, t })}
    </div>
  );

  const actionCell = ({ data, index }) => (
    <>
      <Button
        style={{
          width: '26px',
          height: '25px',
          marginRight: '3px',
        }}
        icon="next"
        func={() => handleOrdering(data.wla_activity_type_id, 'move_up')}
      />
      <Button
        style={{
          width: '26px',
          height: '25px',
          marginRight: '10px',
        }}
        icon="prev"
        func={() => handleOrdering(data.wla_activity_type_id, 'move_down')}
      />
      <ButtonEdit
        icon="edit"
        func={() => {
          setShowModal(true);
          setTypeForm('edit');
          setId(index);
          setDataEdit(data);
        }}
      >
            &nbsp;&nbsp;
        {t('org.structure_view.modal.edit')}
      </ButtonEdit>
    </>
  );

  const columns = [
    {
      name: 'No',
      sortField: true,
      selector: (_, i) => i + 1,
      cellStyle: { verticalAlign: 'middle' },
      width: '5%',
    },
    {
      name: t('biz_process.tree.title'),
      sortField: true,
      selector: (row) => row.activity_name,
      width: '21%',
      style: {
        padding: '0 2px 0 0',
      },
    },
    {
      name: t('job_desc.status'),
      sortField: 'status',
      width: '12%',
      center: true,
      cell: (row) => dataStatusCell({ row, t }),
    },
    {
      name: t('company.order'),
      sortField: true,
      selector: (row) => row.order,
      center: true,
      width: '8%',
    },
    {
      name: t('org.index_view.last_update'),
      sortField: true,
      selector: (row) => dayjs(row.updated_at).format('D MMM YYYY') ?? '-',
      center: true,
      width: '14%',
    },
    {
      name: t('wla.status.table.created_by'),
      sortField: true,
      selector: (row) => row.member?.name ?? '-',
      center: true,
      width: '15%',
    },
    {
      name: t('org.employee.action'),
      sortField: true,
      style: {
        justifyContent: 'center',
      },
      center: true,
      width: '25%',
      cell: (row, i) => (
        actionCell({ data: row, index: i })
      ),
    },
  ];

  return (
    <>
      {showModal && (
        <ModalActivityType
          innerRef={innerRef}
          modal={showModal}
          funcModal={setShowModal}
          ids={id}
          dataActivityType={dataEdit}
          funcId={() => setId}
          typeForm={typeForm}
          t={t}
        />
      )}
      <div
        className="tab-pane active position-relative"
        id="activity_type_list"
        role="tabpanel"
        style={{
          minHeight: '700px',
        }}
      >
        { keyCompanyType ? <LoadingCustom style={{ height: '100px' }} /> : (
          <>
            <div className="row">
              <div className="col-8">
                <h4 className="title">{t('workload_landing.type_activity')}</h4>
              </div>
              <div className="col-4">
                <ButtonMod
                  icon="create"
                  func={() => {
                    setShowModal(true);
                    setTypeForm('create');
                  }}
                >
                  &nbsp;&nbsp;
                  {t('board.add')}
                </ButtonMod>
              </div>
            </div>
            <CustomTableMod>
              <CustomTable
                columns={columns}
                data={ActivityTypeList}
                customStyles={customStyles}
              />
            </CustomTableMod>
          </>
        ) }
      </div>
    </>
  );
}

export default Index;
